import { INTERFACE } from '@/utils/INTERFACE';
import { isApp } from '@/utils/page';
import _ from 'lodash';

export function getLink(target, ...args) {
	var url = ''
	var _target = target
	if (isApp()) {
		target = target.replace('.mob', '.app')
	}
	try {
		var api = _.get(INTERFACE(), target)
		if (!api) {
			api = _.get(INTERFACE(), _target)
		}
		if (api instanceof Function) {
			url = api(...args)
		} else {
			url = api
		}
	} catch (err) {
		console.warn('error: module-function: link ', target, err)
	}
	if (isApp()) {
		url = url.replace(/\/m\//, '/app/')
	}
	return url
}